function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoadIcon = function SvgRoadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 122.88 122.56"
    },
    viewBox: "0 0 122.88 122.56"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 122.56 38.12 0h46l38.75 122.56H0zm71.1-9.66H51.78l1.57-23.31h16.17l1.58 23.31zM69 74.35H53.88l.52-23.32h14.08L69 74.35zm-1.05-38.7H54.92l.52-23.31H66.9l1.05 23.31z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgRoadIcon;